import { useOutletContext } from "react-router";
import type { BlogLoaderContext } from "~/entities/global/types";
import type { ProductPrice, ProductTile } from "~/entities/product/types";
import BlogSidebar from "~/routes/pages/blog/components/BlogSidebar";
import "./style.css";

type Props = {
  query?: string;
  relatedProducts?: ProductTile[];
  relatedProductPrices?: Promise<ProductPrice[] | null>;
};

const BlogContentWithSidebar: React.FC<React.PropsWithChildren<Props>> = ({
  query,
  relatedProducts,
  relatedProductPrices,
  children,
}) => {
  const { categories } = useOutletContext<BlogLoaderContext>();

  return (
    <>
      <div className="blog-content">{children}</div>
      <BlogSidebar
        categories={categories}
        query={query}
        relatedProducts={relatedProducts}
        relatedProductPrices={relatedProductPrices}
      />
    </>
  );
};

export default BlogContentWithSidebar;
